import useTokenStore from '~/store/token'
import useUserStore from '~/store/user'
import useAuthStore from '~/store/auth'
import { useCookie } from '#imports'
import { decodeJwtToken } from '~/utils/cookie'

export default defineNuxtRouteMiddleware(async () => {
    if (process.env.MODE === 'test') return
    const userStore = useUserStore()
    const tokenStore = useTokenStore()

    const tokenFromCookies = useCookie<string>('session', {
        domain: useRuntimeConfig().public.COOKIE_DOMAIN as string
    })

    // Token in store but no token in cookies
    if (tokenStore.token && !tokenFromCookies.value) {
        tokenFromCookies.value = tokenStore.token
    }

    let decodedUserId: number | undefined
    let isBoostUser: boolean | undefined
    let expirationDate = new Date()

    if (tokenFromCookies.value) {
        ;[decodedUserId, expirationDate, isBoostUser] = decodeJwtToken(
            tokenFromCookies.value
        )
    }

    // Expired token OR no token in store + no token in cookies
    if (
        new Date() >= expirationDate ||
        (!tokenFromCookies.value && !tokenStore.token)
    ) {
        await useAuthStore().getAnonymousToken()
        ;[decodedUserId, expirationDate, isBoostUser] = decodeJwtToken(
            tokenStore.token
        )
        tokenFromCookies.value = tokenStore.token // Saves it in the cookies
    }

    if (tokenFromCookies.value) {
        tokenStore.token = tokenFromCookies.value
        tokenStore.tokenExpirationDate = expirationDate.toString()
    }

    // User related actions
    if (decodedUserId) {
        userStore.setUserId(decodedUserId)
        await userStore.fetchLegacyUserData()
        await userStore.fetchUserAddresses()
        await userStore.fetchUserRank()
        await userStore.checkIfUserHasChargemapPass()
        await userStore.fetchUserTeslaLinkStatus()

        if (isBoostUser) {
            userStore.setIsBoostUser(true)
        }
    }
})
